export const NON_BREAKABLE_SPACE = String.fromCharCode(160); // "\xa0";

/**
 * There is no monospace token in the theme. Shared rather than per-feature
 * because the two transcript readers — Follow Ups' and the Ambient Scribe
 * details tab — must render their speaker gutters and timestamps in the same
 * typeface; bare `monospace` resolves to a different font on most machines.
 */
export const MONO_FONT_FAMILY =
  'ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace';

export const JOTFORM_URL = "https://suno.jotform.com/";

export const WORD_PROCESSOR_DELIVERED_AT_DATE = new Date("2023-08-20");
